import { createApp } from 'vue';
import GnavNotification from '../components/GnavNotification.vue';

export default function vueMount() {
	if (document.getElementById('gnavNotice')) {
		const appGnavNotice = createApp(GnavNotification);
		appGnavNotice.mount('#gnavNotice');
	}

	if (document.getElementById('gnavHamburgerNotice')) {
		const appGnavNotice = createApp(GnavNotification);
		appGnavNotice.mount('#gnavHamburgerNotice');
	}
}
